import { EMPTY_OBJECT } from '../../../../constants/common'
import { REQUEST_PROFILE_CHANGE_TYPE } from '../../../../constants/request'
import { useNotification } from '../../../../hooks'
import { isValueStringType } from '../../../../utils/common'
import { getFeedbackByUuid } from '../../../Newsboard'
import { parseFeedbackData, RatingEditModal } from '../../../Rating'
import { useRequestProfileContext } from '../useRequestProfileContext'

export function useRequestProfileRatingActions() {
  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleCloseModal, handleReloadAfterChange, requestData, setModal } =
    useRequestProfileContext()

  const requestId = requestData?.id

  async function reloadData() {
    return handleReloadAfterChange(REQUEST_PROFILE_CHANGE_TYPE.rating)
  }

  function handleSuccess(notificationKey) {
    handleAddSuccessNotification(notificationKey)
    reloadData()
  }

  function openRatingModal(ratingData) {
    const feedbackUuid = ratingData?.feedback?.uuid

    const notificationKey = feedbackUuid
      ? 'Notification.CommonTitleSavedKey'
      : 'Notification.CommonTitleCreatedKey'

    function handleUpdateListData() {
      handleSuccess(notificationKey)
    }

    setModal(
      <RatingEditModal
        withComment
        withFiles
        ratingData={ratingData}
        requestId={requestId}
        onClose={handleCloseModal}
        onUpdateListData={handleUpdateListData}
      />
    )
  }

  function handleOpenRating(feedbackUuid, permissions) {
    // Called both programmatically (with a uuid) and directly as a click
    // handler (the event arg means "add new"), so only treat a string as an
    // existing feedback to edit.
    if (!isValueStringType(feedbackUuid)) {
      openRatingModal(EMPTY_OBJECT)

      return
    }

    getFeedbackByUuid(feedbackUuid)
      .then(({ data }) => {
        openRatingModal(parseFeedbackData(data, permissions))
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  return {
    handleOpenRating,
    permissions: requestData?.permissions,
  }
}
